import owd from 'owd/owd';

export class AjaxResolver {
	constructor(app, href, isBack, pushState) {
		this.app = app;
		this.dom = app.dom;
		this.href = href;
		this.isBack = isBack;
		this.pushState = pushState;
	}

	shouldPushState() {
		return true;
	}

	pageIn() {
		throw new Error("pageIn() method should be implemented and return a promise in AjaxResolver implementation");
	}

	pageOut() {
		throw new Error("pageOut() method should be implemented and return a promise in AjaxResolver implementation");
	}

	updateContent($loadedContent) {
		throw new Error("updateContent() method should be implemented and return a promise in AjaxResolver implementation");
	}
}

export default class Ajax extends owd.Module {
	init() {
		this._ctr = 1;
		this._preloaded = {};
		this.inProgress = false;
		this.baseUrl = this.app.dom.$body.data('base-href');

		$('img').attr('data-img-load', true);

		this.app.dom.$body.on('click', 'a:not(.no-ajax):not([hreflang])', (e) => {
			const $a = $(e.currentTarget);
			const href = $a.attr('href');

			if (href.indexOf('mailto:') < 0 &&
				href.indexOf('skype:') < 0 &&
				href.indexOf('tel:') < 0 &&
				href.indexOf('fax:') < 0 &&
				href.indexOf('.pdf') < 0 &&
				href != '#' &&
				href.replace(this.baseUrl, '').indexOf('#') !== 0 &&
				((href.indexOf(this.baseUrl) >= 0 && href.indexOf(this.baseUrl) <= 7) || href.indexOf('://') < 0)) {
				e.preventDefault();
				e.stopPropagation();

				this.loadPage(href, true, $a.attr('data-ajax-resolver'));
			}
		});

		this.app.dom.$window.on('load', () => {
			this.currentStateCtr = this._ctr;
			history.replaceState({ internal: true, ctr: this._ctr++ }, null, document.URL);
		});

		this.app.dom.$window.on('popstate', (e) => {
			if (e.originalEvent.state && e.originalEvent.state.internal) {
				this.loadPage(location.href, false, null, e.originalEvent.state.ctr < this.currentStateCtr, true);
				this.currentStateCtr = e.originalEvent.state.ctr;
			}
		});
	}

	registerResolver(name, Resolver) {
		if (this.resolvers === undefined || this.resolvers === null) {
			this.resolvers = {};
		}

		this.resolvers[name] = Resolver;

		return this;
	}

	registerDefaultResolver(Resolver) {
		this.registerResolver('default', Resolver);

		return this;
	}

	getResolver(name) {
		if (name === undefined || name === null) {
			name = 'default';
		}

		if (this.resolvers[name] === undefined) {
			throw new Error('Resolver not registered for key ' . name);
		}

		return this.resolvers[name];
	}

	loadPage(href, pushState, resolverName, isBack, forceLoad) {

		this.inProgress = true;

		const hrefParts = href.split('#');
		const hrefNoHash = hrefParts[0];
		const hrefHash = hrefParts.length > 1 ? hrefParts[1] : null;

		const resolver = new (this.getResolver(resolverName))(this.app, href, isBack, pushState);

		const loadPromise = this.loadIntoTemp(hrefNoHash);

		this.app.dom.$window.trigger('pageOut');
		resolver.pageOut().then(() => {
			if (pushState === true && resolver.shouldPushState()) {
				history.pushState({
					internal: true,
					ctr: this._ctr++
				}, null, href);
			}
		this.app.dom.$window.trigger('pageOutDone');
			return loadPromise;
		}).then(($temp) => {
			if (pushState === true && resolver.shouldPushState()) {
				if ($temp.find('[data-head-title]').length) {
					$('[data-head-title]').html($temp.find('[data-head-title]').text());
					history.replaceState({
						internal: true,
						ctr: this._ctr
					}, $temp.find('[data-head-title]').text(), href);
				}
			}

			return resolver.updateContent($temp);
		}).then(($old, $new) => {
			$old.trigger('destroy');
			$old.find('[data-owd-component]').trigger('destroy');
			$old.remove();

			$new.find('img').attr('data-img-load', true);

			this.app.tick($('.overall'));
			this.app.dom.$window.trigger('ajaxload');
			this.app.dom.$window.trigger('pageIn');

			return resolver.pageIn();
		}).then(() => {
			this.app.dom.$window.trigger('pageInDone');
		});
	}

	loadIntoTemp(href) {
		const deferred = $.Deferred();
		const $temp = $('<html>');

		$temp.load(href + ' .overall, [data-head-title]', (response) => {
			if (window.dataLayer !== undefined) {
				try {
					dataLayer.push({
						'event': 'content-view',
						'content-name': href.replace(this.baseUrl, '')
					});
				} catch (e) {}
			}

			if (window.ga !== undefined) {
				try {
					ga('send', 'pageview', {
						page : href.replace(this.baseUrl, ''),
						title: $temp.find('title').text()
					});
				} catch (e) {}
			}
			
			deferred.resolve($temp);
		});

		return deferred.promise();
	}
}
